// extracted by css-extract-rspack-plugin
module.exports =  {"root":"TeamListFooter-m__root___l0XZA","text":"TeamListFooter-m__text___4G7qn"};